<div class="login-container">
  <app-mobile-header [title]="'login.register'" [manualBackEvent]="true"
    (onManualBackEvent)="onClickBack()"></app-mobile-header>

  <div class="login-content">
    <div class="login-mascot">
      <img src="assets/generalImage/user.svg" loading="lazy" alt="mascot" />
      <h1>{{'desc.enter.phoneno.to.get.start' | translate}}</h1>
    </div>

    <form (ngSubmit)="onSubmit()" (keydown.enter)="$event.preventDefault(); onSubmit()" [formGroup]="fgroup" class="loginform">
      <div class="mobile-field">
        <ngx-intl-tel-input [cssClass]="" [enableAutoCountrySelect]="telInpSetting.enableAutoCountrySelect"
          [customPlaceholder]="telInpSetting.customPlaceholder | translate"
          [enablePlaceholder]="telInpSetting.enablePlaceholder" [searchCountryFlag]="telInpSetting.searchCountryFlag"
          [searchCountryField]="telInpSetting.searchCountryField"
          [selectFirstCountry]="telInpSetting.selectFirstCountry" [phoneValidation]="telInpSetting.phoneValidation"
          [inputId]="'phoneNo'" [separateDialCode]="telInpSetting.separateDialCode"
          [preferredCountries]="telInpSetting.preferredCountries"
          [selectedCountryISO]="telInpSetting.selectedCountryISO" name="phone" formControlName="phoneNo" #phone_number
          autofocus #mobilefocus [ngClass]="{'invalid-p-inputtext': isInvalid }">
        </ngx-intl-tel-input>
        <i class="icon-times" *ngIf="phone_number.value && phone_number.value.length > 0"
          (click)="fgroup.get('phoneNo')?.reset() "></i>

        <i class="icon-alert" *ngIf="isInvalid"></i>

        <div class="invalid-feeback" *ngIf="isInvalid">
          {{ 'error.invalid.mobile.number' | translate }}
        </div>
      </div>

      <app-button [buttonName]="'button.continue'" (onClickEvent)="onSubmit()" class="submit-btn"
        [disabled]="!phone_number.value || isSubmitting || submitted"></app-button>

      <app-button [textButton]="true" [buttonName]="'button.continue.as.guest'" class="continueAsGuest-btn"
        *ngIf="showContGuest" (onClickEvent)="continueAsGuest()"></app-button>
    </form>
  </div>

  <div class="login-footer">
    <app-termandprivacypolicy></app-termandprivacypolicy>
  </div>
</div>
